import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useInitGlossaryTooltips } from '../../../hooks/useInitGlossaryTooltips';
import { CompareFeatureItem } from './CompareFeatureItem';
export const CompareFeatures = ({ attributes, compareFeaturesSwiperInstances, setSwiperInstances, }) => {
    const { isGlossaryLoaded, shouldInitGlossaryTooltips } = useInitGlossaryTooltips();
    const setSwiperInstance = (swiper, attribute) => {
        const existedInstanceIndex = compareFeaturesSwiperInstances.findIndex(sw => attribute === sw.attribute);
        if (existedInstanceIndex === -1) {
            compareFeaturesSwiperInstances.push({
                attribute,
                swiper,
            });
        }
        else {
            compareFeaturesSwiperInstances[existedInstanceIndex].swiper = swiper;
        }
        setSwiperInstances(compareFeaturesSwiperInstances);
    };
    useEffect(() => {
        const swiperInstances = compareFeaturesSwiperInstances.filter(swiper => !!attributes.find(feature => swiper.attribute === feature.attribute));
        setSwiperInstances(swiperInstances);
    }, [attributes]);
    return (_jsx(_Fragment, { children: attributes.map((feature) => (_jsx(CompareFeatureItem, { feature: feature, isGlossaryLoaded: isGlossaryLoaded, shouldInitGlossaryTooltip: shouldInitGlossaryTooltips, setSwiperInstance: setSwiperInstance }, feature.attribute))) }));
};
